import { StockClassAdditionalInformation } from '@commenda/types/src/cap-table/types';
import { fetcher } from '@commenda/utils';
import { StockClassType } from '@prisma/client';

interface UpdateStockClassParams {
  type?: StockClassType;
  name?: string;
  additionalInformation?: StockClassAdditionalInformation;
  corporationId?: number;
}

export async function updateStockClass(
  stockClassId: string,
  params: UpdateStockClassParams
) {
  try {
    const res = await fetcher(`capTable/stockClass/${stockClassId}`, {
      method: 'POST',
      body: params,
    });

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
}
